import { Container, Box } from '@mui/material';
import React from 'react';
import MyProfileForm from '../../../components/my-profile-form';

const MyProfileView = ({
  loggedInTravelerId,
  navigateToAccount,
}: {
  loggedInTravelerId: string | undefined;
  navigateToAccount: () => void;
}) => {
  if (!loggedInTravelerId) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          pt: 3.75,
          pb: 12,
        }}
      >
        <MyProfileForm travelerId={loggedInTravelerId} onCancel={navigateToAccount} onSuccess={navigateToAccount} />
      </Box>
    </Container>
  );
};

export default MyProfileView;
